import { Drawer, Hidden, IconButton } from '@mui/material';
import { MainBarHeader } from './MainBarHeader';
import { useStyles } from './styles/MobileDrawer.styles';
import { Close } from '@mui/icons-material';

interface MobileDrawerProps {
    sidebarOpen: boolean;
    handleToggle: () => void;
}

export const MobileDrawer = ({ sidebarOpen, handleToggle }: MobileDrawerProps) => {
    const classes = useStyles();

    return (
        <nav className={classes.drawer}>
            <Hidden smUp implementation='css'>
                <Drawer
                    variant='temporary'
                    anchor={'left'}
                    open={sidebarOpen}
                    onClose={handleToggle}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}>
                    <div className={classes.drawerHeader}>
                        <img className={classes.logoSidebar} src='logo.png' />

                        <IconButton onClick={handleToggle} className={classes.closeMenuButton}>
                            <Close />
                        </IconButton>
                    </div>

                    <MainBarHeader mobile={true} onClick={() => handleToggle()} />
                </Drawer>
            </Hidden>
        </nav>
    );
};
